import { Flex, Text, useToast } from '@chakra-ui/react'
import { useState } from 'react'
import { MdClose } from 'react-icons/md'
import Modal from 'react-modal'
import { ButtonCmp } from '../../../../components/ButtonCmp'
import { InputCmp } from '../../../../components/InputCmp'
import { appApi } from '../../../../services/appApi'

interface props {
  isOpen: boolean
  onRequestClose: () => void
  feedbackId: string
  onConfirm: (newGrupo: string) => void
}

export const ModalCriarGrupo: React.FC<props> = ({ isOpen, onRequestClose, feedbackId, onConfirm }) => {
  Modal.setAppElement('#root')
  const toast = useToast()
  const [NomeGrupo, setNomeGrupo] = useState('')
  function onCreate(): void {
    appApi.post(`FeedbackPersonalizado/${feedbackId}/Grupo`, { texto: NomeGrupo })
      .then(res => {
        onConfirm(res.data)
        toast({
          title: 'Grupo criado com sucesso!',
          duration: 4000,
          position: 'top',
          status: 'success'
        })
      })
      .catch(err => console.log(err))
  }

  return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            overlayClassName='react-modal-overlay'
            className='react-modal-content-poupUp'
        >
            <Flex justifyContent={'space-between !important'} width={'100%'}>
                <Text fontSize={'16px'} fontWeight={700}>Criar grupo</Text>
                <MdClose size={18} color={'var(--Red)'} cursor={'pointer'} onClick={onRequestClose} />
            </Flex>
            <Flex flexDir={'column'} gap={'.5rem'} my={'.75rem'}>
                <InputCmp
                    label='Nome do grupo'
                    value={NomeGrupo}
                    OnChange={setNomeGrupo}
                />
            </Flex>
            <Flex gap={'.5rem'} justifyContent={'end'}>
                <ButtonCmp VarColor='c6' onClick={onRequestClose}>Cancelar</ButtonCmp>
                <ButtonCmp VarColor='Green2' onClick={onCreate}>Criar</ButtonCmp>
            </Flex>

        </Modal>
  )
}
